<template>
    <div id="bohemia-header-toggle-navigation-wrapper" :class="{active : active}">
        <button @click="onClick"
                class="bohemia-header-toggle-navigation-button"
                :class="{'tcon-transform' : active}" aria-label="toggle menu">
            <span class="tcon tcon-plus tcon-plus--minus">
                <span class="tcon-visuallyhidden">toggle menu</span>
            </span>
        </button>
    </div>
</template>

<script>
    export default {
        name   : 'bohemia-nav-toggle',
        props  : {
            active: {
                type   : Boolean,
                default: false
            }
        },
        methods: {
            onClick() {
                this.$emit('toggle');
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    @import '/../../../assets/scss/breakpoints';
    @import '/../../../assets/scss/header/vars';

    #bohemia-header-toggle-navigation-wrapper {
        align-items: center;
        display: none;
        margin-right: 1em;
        position: relative;
        transform: translateX(0);
        transition: all .5s;
        z-index: 10;

        @media (max-width: $brMedium) {
            display: flex;
        }
    }

    $tcon-size: 20px !default;
    $tcon-transition: .3s !default;
    $tcon-jstransform: 'tcon-transform' !default;

    $tcon-plus-bg: transparent !default;
    $tcon-circle-radius: 80% !default;
    $tcon-plus-radius: ($tcon-size / 4) !default;
    $tcon-plus-color: #fff !default;
    $tcon-remove-color: #fff !default;

    button{
        appearance: none;
        border: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;
        background: transparent;
        outline: none;
        height: 40px;
        width: 40px;
    }

    .tcon {

        height: $tcon-size;
        transition: $tcon-transition;
        width: $tcon-size;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color: transparent;

        > * {
            display: block;
        }

        &:hover,
        &:focus {
            outline: none; // see issue #36 https://github.com/grayghostvisuals/transformicons/issues/36
        }
        &::-moz-focus-inner {
            border: 0;
        }
    }

    .tcon-plus {
        height: $tcon-size / 2;
        position: relative;
        transform: scale(.75);
        width: $tcon-size;

        &::before,
        &::after {
            content: "";
            border-radius: 2px;
            display: block;
            width: 85%;
            height: 25%;
            position: absolute;
            top: 37%;
            left: 8%;
            transition: $tcon-transition;
            background: #fff;
        }

        &:after {
            transform: rotate(90deg);
        }
    }

    .tcon-plus--minus {
        &.#{$tcon-jstransform} {
            &::before {
                transform: rotate(180deg) translate(0, 0);
                width: 62%;
            }

            &::after {
                transform: rotate(-180deg) translate(-37.5%, 0);
                width: 62%;
            }
        }
    }

    // see issue #7 https://github.com/grayghostvisuals/transformicons/issues/7#issuecomment-59813596
    .tcon-visuallyhidden {
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;

        &:active,
        &:focus {
            clip: auto;
            height: auto;
            margin: 0;
            overflow: visible;
            position: static;
            width: auto;
        }
    }

</style>



// WEBPACK FOOTER //
// node_modules/@bistudio/bohemia-vue-components-old/src/components/header/partials/Toggle.vue